<template>
  <div class="navbar" :style="navbarStyle">
    <div class="bar">
      <!-- 左侧部分 -->
      <div class="navbar-left">
        <div class="logo">
          <svg id="_图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510.24 510.24" class="logo-icon">
            <rect class="cls-2" width="510.24" height="510.24" rx="93.3" ry="93.3"/>
            <path class="cls-1" d="M426.84,234.48c2.01,1.57,1.92,8.68,1.93,13.86-.17,12.08.36,27.88-.27,39.84-.3,6.34-4.59,6.61-9.81,6.66-7.14.07-14.64.01-21.89.03-3.02,0-5.97,0-8.69,0-9.46.06-16.15-.22-22.49.9-2.69.51-5.35,1.4-7.69,3.03-8.44,5.4-7.66,19.27,1.76,22.69,8.12,3.05,16.03,2.27,24.81,2.52,12.39.04,31.03-.06,41.06.04,4.41.08,8.83.13,8.87,6.5.43,15.13.04,46.57.15,62.71-.09,4.75.4,10.71-5.14,10.76-13.99.65-36.36,0-51.8.22-9.86.03-19.22,0-29.42-.97-44.33-3.38-81.61-26.34-84.37-79.92-.92-29.8-.1-69.47-.37-98.7-1.06-35.5,4.57-65.33,32.02-85.01,32.73-22.79,74.45-15.93,112.78-17.04,10.59.33,16.46-.68,23.23.58,4.38.84,2.74,11.54,3.08,17.27,0,13.91,0,36.18,0,50.29-.04,7.68.36,12.65-6.37,12.75-10.78.44-22.4.08-33.22.19-11.55.24-18.49-.85-28.15,2.55-10.25,3.43-13.41,15.18-3.82,21.9,4.08,2.73,8.83,3.49,13.6,3.88,8.41.61,22.16.32,32.66.39,4.95.22,14.72-.86,17.46,2.02l.08.09Z"/>
            <rect class="cls-1" x="78.78" y="124.4" width="177.23" height="56.69" rx="25.51" ry="25.51"/>
            <rect class="cls-1" x="130.32" y="198.14" width="95.43" height="56.69" rx="25.51" ry="25.51"/>
            <rect class="cls-1" x="100.92" y="271.88" width="95.43" height="56.69" rx="25.51" ry="25.51"/>
            <rect class="cls-1" x="78.78" y="344.83" width="177.23" height="56.69" rx="25.51" ry="25.51"/>
          </svg>
          <a href="/">ZError题库</a>
        </div>
      </div>

      <!-- 右侧部分 -->
      <!-- 修改正常屏幕的菜单链接 -->
      <div class="navbar-right">
        <!-- 正常屏幕显示的菜单项 -->
        <div class="links">
          <a :class="{'active': isActive('/')}" href="/">首页</a>
          <a :class="{'active': isActive('/dashboard')}" href="/dashboard">我的(OCS题库配置)</a>
        </div>
      
        <!-- 汉堡按钮 -->
        <div class="hamburger" v-if="isMobile" @click="toggleMenu">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
      
      <!-- 修改移动端菜单 -->
      <transition name="menu" @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div class="screen" v-if="menuVisible" ref="screen">
          <a href="/">主页</a>
          <a v-if="isLoggedIn" href="/dashboard">我的</a>
        </div>
      </transition>
    </div>
    <!-- 使用 transition 包裹，触发动画 -->
    <transition name="menu" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div class="screen" v-if="menuVisible" ref="screen">
        <a href="/">主页</a>
        <a v-if="!isLoggedIn" href="/login">登录</a>
        <a v-if="isLoggedIn" href="/dashboard">我的</a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoggedIn: false, // 控制是否显示登录/登出
      isMobile: false,    // 判断是否为小屏幕
      menuVisible: false, // 控制菜单是否显示
      currentPath: window.location.pathname,  // 当前路径
      highZIndex: false,  // 控制是否使用高 z-index
    };
  },
  computed: {
    // 计算 navbar 的样式
    navbarStyle() {
      return {
        zIndex: this.highZIndex ? '99999999999999999999' : '1'
      };
    }
  },
  methods: {
    logout() {
      this.isLoggedIn = false;
      localStorage.removeItem("token");
      alert("Logged out successfully");
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      this.highZIndex = this.menuVisible;
      if (this.menuVisible) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    },
    // Enter 动画之前
    beforeEnter(el) {
      el.style.opacity = 0;
 
    },
    // Enter 动画
    enter(el, done) {
      el.offsetHeight; // 触发 reflow，确保过渡效果
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      el.style.opacity = 1;

      done();
    },
    // Leave 动画
    leave(el, done) {
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      el.style.opacity = 0;

      done();
    },
    isActive(path) {
      return this.currentPath === path;  // 如果当前路径等于链接的路径，则返回true，添加active类
    },
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (token) {
      this.isLoggedIn = true;
    }

    // 判断屏幕尺寸，设定 isMobile 的值
    this.isMobile = window.innerWidth <= 768;

    // 监听屏幕变化
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.menuVisible = false; // 如果从小屏幕切换回大屏幕，关闭菜单
        this.highZIndex = false;  // 恢复原来的 z-index
      }
    });
    this.currentPath = window.location.pathname;  // 获取当前页面路径
  },
};
</script>

<style scoped>
.navbar {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 99999999999; /* 默认 z-index */
  transition: z-index 0.01s; /* 添加过渡效果 */
  align-items: center;
  border-bottom: #ececec solid 1px;
}

/* 其他样式保持不变 */


.bar {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  background-color: white;
  width: 100%; 
  max-width: 1280px;

}

.navbar-left {
  display: flex;
  align-items: center;
  margin-right: 0; 
  margin-left: 20px;
}

.navbar-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
}

.navbar .logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  width: 30px;
  height: 30px;
}

.navbar .navbar-right .links {
  display: flex;
  gap: 20px;
}

.navbar .navbar-right .links a {
  text-decoration: none;
  color: rgb(87, 87, 93);
  font-size: 14px;
  padding: 15px 12px;

  transition: background-color 0.3s;
}

.navbar .navbar-right .links a.active {
  border-bottom: 2px solid rgb(254, 208, 1); /* 为选中的链接添加下划线 */
  color: rgb(254, 208, 1); /* 可选：让选中的链接文字颜色变为黄色 */
}

.navbar .navbar-right .links a:hover {
  color : rgb(254,208,1)
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 15px;
  cursor: pointer;
}

.hamburger .line {
  height: 2px;
  background-color: #000;
  border-radius: 2px;
}

/* 菜单样式 */
.screen {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* 背景色为半透明 */
  position: fixed;
  top: 35px; /* 设置为 bar 的高度，避免覆盖 bar */
  left: 0;
  height: calc(100% - 40px); /* 高度为剩余的空间，避免覆盖 bar */
  z-index: 999999999999999999; /* 确保菜单显示在其他内容之上 */
  justify-content: center;
  padding-bottom: 20px; /* 保证底部留出空间 */
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease; /* 过渡效果 */
  backdrop-filter: blur(10px); /* 添加毛玻璃模糊效果 */
  -webkit-backdrop-filter: blur(10px); /* 支持Safari浏览器 */
}
/* 文字从上到下的动画，和放大动画 */
.screen a {
  font-size: 20px;
  padding: 15px 0px;
  width: 100%;
  text-align: center;
  color: rgb(0, 0, 0);
  text-decoration: none;
  transition: font-size 0.3s ease, transform 0.3s ease; /* 添加 transform 的过渡 */


}

/* 文字的从上到下的淡入动画 */
.screen.show a {
  opacity: 1;

}

/* 悬停时放大字体 */
.screen a:hover {
  font-size: 25px;
}

/* 小屏幕时，显示汉堡按钮，并隐藏右侧的菜单项 */
@media (max-width: 768px) {
  .bar {

    height: 35px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .navbar .navbar-right .links {
    display: none; /* 小屏幕下隐藏菜单项 */
  }

  .hamburger {
    display: flex; /* 小屏幕下显示汉堡按钮 */
  }
}

.navbar .logo a {
  font-size: 24px;
  text-decoration: none;
  background: linear-gradient(45deg, #f8b62d, #ff7043);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  transition: all 0.3s ease;
}


.logo-icon {
  width: 30px;
  height: 30px;
  /* 添加以下样式 */
  .cls-1 {
    fill: #f7f8f8; /* 白色部分 */
    stroke-width: 0px;
  }
  
  .cls-2 {
    fill: #f8b62d; /* 黄色部分 */
    stroke: #a2d9ed;
    stroke-miterlimit: 10;
    stroke-width: .5px;
  }
}
</style>
